import React from 'react';
import './Footer.scss';


export default () => (
  <footer className="footer">
    <p className="footer__copyright">Icons made by <a href="https://www.flaticon.com/authors/eucalyp" title="Eucalyp">Eucalyp</a> from <a href="https://www.flaticon.com/" title="Flaticon"> www.flaticon.com</a></p>
  </footer>
)